import { render, staticRenderFns } from "./LiveSpeakers.vue?vue&type=template&id=69ed4f28&"
import script from "./LiveSpeakers.vue?vue&type=script&lang=js&"
export * from "./LiveSpeakers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports